/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { coreService } from 'network-utils';

export const getLearnData = 'learn-data';

export const useGetLearnData = (token: string) => {
    return useQuery([getLearnData, token], () => coreService.learnApi.getLearnData(token), {
        enabled: !!token,
        keepPreviousData: true
    });
};
